export const rewashVisualIds = [
  { id: '80dc4c449b77a439d905', title: 'percentageOfVolumeByDate' },
  { id: 'd282e5ffa6e4dd290320', title: 'rewashByReason30Days' },
  { id: '4918f8008876ae9d202f', title: 'percentageByEmployee' },
];
